import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatDataSourceGeneric} from "@Services/base/daoService";
import {ModelPjType} from "app/dar/common/services/model-pj/model-pj.model";
import {ActionDataTable, ColumnDataTable, DataTableComponent} from "@Common/widgets/general/data-table";
import {ModelPjTypeService} from "app/dar/common/services/model-pj/model-pj-type.service";
import {MatDialog} from "@angular/material/dialog";
import {SubSink} from "@Common/core/utils/subsink";
import {
  ModelPjTypeEditComponent
} from "app/dar/common/model-pj/model-pj/model-pj-type-edit/model-pj-type-edit.component";

@Component({
  selector: 'app-model-pj-type',
  templateUrl: './model-pj-type.component.html',
  styleUrls: ['./model-pj-type.component.scss']
})
export class ModelPjTypeComponent implements OnInit, OnDestroy {
  subSink = new SubSink();
  pjTemplateTypeSource: MatDataSourceGeneric<ModelPjType> = new MatDataSourceGeneric<ModelPjType>();
  @ViewChild(DataTableComponent, {static: true}) dataTable: DataTableComponent;


  columns: ColumnDataTable[] = [
    {
      columnDef: 'name', header: 'Nom',
      display: (element: ModelPjType) => `${element.name}`,
      sort: true, flex: 15
    },
    {
      columnDef: 'description', header: 'Description',
      display: (element: ModelPjType) => `${element.description}`,
      sort: true
    },
  ];

  actions: ActionDataTable[] = [
    {
      label: 'Editer', tooltip: 'Editer la catégorie',
      icon: 'edit',
      click: (row: ModelPjType) => this.editType(row)
    },
  ];

  constructor(
    private pjTemplateTypeSvc: ModelPjTypeService,
    private dialog: MatDialog,
  ) {
    this.pjTemplateTypeSource.daoService = pjTemplateTypeSvc;
  }

  ngOnInit(): void {
    this.pjTemplateTypeSource.listData$.subscribe(
      data => this.pjTemplateTypeSvc.updateList(data)
    );
  }

  ngOnDestroy() {
    this.subSink.unsubscribe();
  }

  private editType(row: ModelPjType) {
    const dialogRef = this.dialog.open(ModelPjTypeEditComponent, {data: row});
    dialogRef.updateSize('700px');
    dialogRef.updatePosition({top: '50px'});
    this.subSink.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.saveType(result);
      }
    });
  }

  private saveType(data: ModelPjType) {
    this.subSink.sink = this.pjTemplateTypeSvc.updateOrcreate(data).subscribe((res) => this.dataTable.reload());
  }

  addType() {
    this.editType({});
  }
}
